import { createContext, useContext, useEffect, useState } from "react";
import { erpIcon, faqIcon, loadManagementIcon, reportIcon } from "images";

// Create the context
const AppContext = createContext();

// Provider component
export const ContextProvider = ({ children }) => {
  const storedTheme = JSON.parse(localStorage.getItem("myTheme"));
  const storedAllowEnterToSubmit = JSON.parse(
    localStorage.getItem("allowEnterToSubmit")
  ); // Retrieve the value from localStorage

  const [myTheme, setMyTheme] = useState(
    storedTheme || { name: "gora", color: "#00deff" }
  );
  const [leftSidebar, setLeftSidebar] = useState(
    JSON.parse(localStorage.getItem("leftSidebar") || true)
  );
  const [rightSidebar, setRightSidebar] = useState(
    JSON.parse(localStorage.getItem("rightSidebar") || false)
  );
  const [showConnectWalletModal, setShowConnectWalletModal] = useState(null);
  const [connectedWallet, setConnectedWallet] = useState();

  // Get the initial value from localStorage, or default to true
  const [allowEnterToSubmit, setAllowEnterToSubmit] = useState(
    storedAllowEnterToSubmit !== null ? storedAllowEnterToSubmit : true
  );

  const aiCharacters = [
    {
      icon: erpIcon,
      character: "Best Languages for ERP",
    },
    {
      icon: faqIcon,
      character: "FAQ & Knowledge Base",
    },
    {
      icon: reportIcon,
      character: "Team Productivity Reports",
    },
    {
      icon: loadManagementIcon,
      character: "Lead Management & Follow-ups",
    },
  ];

  // Store the `allowEnterToSubmit` value in localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("leftSidebar", JSON.stringify(leftSidebar));
    localStorage.setItem("rightSidebar", JSON.stringify(rightSidebar));
    localStorage.setItem("myTheme", JSON.stringify(myTheme));
    localStorage.setItem(
      "allowEnterToSubmit",
      JSON.stringify(allowEnterToSubmit)
    );
  }, [allowEnterToSubmit, myTheme, leftSidebar, rightSidebar]);

  return (
    <AppContext.Provider
      value={{
        myTheme,
        setMyTheme,
        leftSidebar,
        setLeftSidebar,
        rightSidebar,
        setRightSidebar,
        showConnectWalletModal,
        setShowConnectWalletModal,
        connectedWallet,
        setConnectedWallet,
        allowEnterToSubmit,
        setAllowEnterToSubmit,
        aiCharacters,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// Custom hook for using the context
export const useAppContext = () => {
  return useContext(AppContext);
};
